import { createContext } from 'react';

type ContextValue = {
  refresh: () => void;
  paid: boolean;
  setPaid: (value: boolean) => void;
};

export default createContext<ContextValue>({
  refresh: () => {},
  paid: false,
  setPaid: () => {},
});
